// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.baseInfo.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './css/public.css'

import store from './js/store'
import api from './js/api'
import face from './js/interface'
import fun from './js/fun'
import md5 from 'js-md5'

Vue.config.productionTip = false
Vue.prototype.$api=api
Vue.prototype.$face=face
Vue.prototype.$fun=fun
Vue.prototype.$md5=md5;

/* eslint-disable no-new */
Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    sessionStorage.removeItem('token');
  }
  let user = sessionStorage.getItem('token');
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js


// WEBPACK FOOTER //
// ./src/main.js